<template>
  <div style="width:100%; text-align: right;">
    <v-btn
      color="primary"
      @click="handleExport"
    >
      <v-icon>mdi-microsoft-excel</v-icon>
      Export
    </v-btn>
  </div>
</template>
<script>
//import * as XLSX from 'xlsx/xlsx.mjs'
import * as XLSX from 'xlsx'
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleExport () {
      /*
      let data = XLSX.utils.json_to_sheet(this.data)
      const workbook = XLSX.utils.book_new()
      const filename = 'cliks'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
      */
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const wb = XLSX.utils.book_new()

        const ws = XLSX.utils.json_to_sheet(this.data)
        XLSX.utils.book_append_sheet(wb, ws, 'clicks')

		const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
		const fileData = new Blob([excelBuffer], { type: fileType })
		var link = document.createElement('A')
		link.href = URL.createObjectURL(fileData)
		link.download = 'clicks'
		//link.download = 'export.csv'
		link.target = '_blank'
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
    },
  },
}
</script>
